var getTitle = (_ref, isMobile) => {
  var propertyTypes = _ref.propertyTypes;
  if (!propertyTypes) {
    return null;
  }
  var selectedTypes = propertyTypes.selected;
  if (selectedTypes.length === 0) {
    return isMobile ? 'All' : 'Property Type';
  }
  var selectedType = selectedTypes.length === 1 && propertyTypes.available.find(each => each.name === selectedTypes[0]);
  return selectedType ? selectedType.label : "".concat(selectedTypes.length, " Property types");
};
var buildPropertyTypeProps = (_ref2, onChange) => {
  var propertyTypes = _ref2.propertyTypes;
  return {
    propertyTypes: propertyTypes ? propertyTypes.available : [],
    selectedTypes: propertyTypes ? propertyTypes.selected : [],
    onChange
  };
};
export default buildPropertyTypeProps;
export { getTitle as getPropertyTypeTitle };